import React, { useState } from 'react';
import { StatusPanel } from './StatusPage';
import AdminUsers from './AdminUsers';

const TABS = [
  { id: 'status', label: 'Status & Feeds' },
  { id: 'users', label: 'Users' },
];

const AdminPage = () => {
  const [tab, setTab] = useState('status');

  return (
    <div className="pb-page">
      <header className="pb-page-header">
        <div>
          <span className="pb-page-eyebrow">▸ Admin</span>
          <h1 className="pb-page-title">Admin Panel</h1>
        </div>
      </header>

      <nav className="pb-header-nav" aria-label="Admin sections">
        {TABS.map((t) => (
          <button
            key={t.id}
            type="button"
            className={`pb-header-nav-link${tab === t.id ? ' active' : ''}`}
            aria-current={tab === t.id ? 'page' : undefined}
            onClick={() => setTab(t.id)}
          >
            {t.label}
          </button>
        ))}
      </nav>

      {tab === 'status' ? <StatusPanel /> : <AdminUsers />}
    </div>
  );
};

export default AdminPage;
